module.exports = __webpack_public_path__ + "img/warning.67699f8f.svg";